import { CountUp } from 'countup.js';
import { $$ } from '../lib/domUtils';

$$('[data-counter]').forEach(el => {
  const number = el.dataset.counter;
  const countup = new CountUp(el, number, {
    duration: 4,
  });

  if (!countup.error && 'IntersectionObserver' in window) {
    el.innerText = '';

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            countup.start();
            observer.unobserve(el);
          }
        });
      },
      {
        root: null,
        threshold: 0.5,
      }
    );
    observer.observe(el);
  }
});
